// extracted by mini-css-extract-plugin
export default {"red":"Icon_red__rTiHB","gray42":"Icon_gray42__ta8qy","gray61":"Icon_gray61__iBSuh","gray85":"Icon_gray85__o1Xrv"};